import { BADGE_SIZE, BUTTON_SIZE, ICON_COLOR, ICON_SIZE, SELECT_FIELD_OPTION_MIN_HEIGHT, TYPE_SPEC, VALIDATION_BADGE, } from './tokens';
export const getIconButtonSize = ({ fieldSize, }) => BUTTON_SIZE[fieldSize];
export const getIconColor = ({ disabled }) => disabled ? ICON_COLOR.DISABLED : ICON_COLOR.DEFAULT;
export const getIconSize = ({ fieldSize }) => ICON_SIZE[fieldSize];
export const getTypeSpec = (fieldSize) => {
    switch (fieldSize) {
        case 'sm':
            return TYPE_SPEC.SM;
        case 'xl':
            return TYPE_SPEC.XL;
        default:
            return TYPE_SPEC.DEFAULT;
    }
};
export const getValidationBadge = ({ fieldSize, validationState = 'default', }) => {
    const badgeConfigs = VALIDATION_BADGE[validationState];
    if (badgeConfigs) {
        return Object.assign(Object.assign({}, badgeConfigs), BADGE_SIZE[fieldSize]);
    }
    return null;
};
export const getSelectOptionListHeight = ({ size = 10 }) => size * SELECT_FIELD_OPTION_MIN_HEIGHT;
